export default __webpack_public_path__ + "static/media/address-book-lg.ad9370f3.svg";